var map = {
	"./customer/components/Overview": [
		672,
		0,
		1,
		2,
		34,
		40
	],
	"./refund-queue/components/Overview": [
		694,
		0,
		1,
		38
	],
	"./saleorder/components/Overview": [
		691,
		0,
		1,
		2,
		4,
		12
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 629;
module.exports = webpackAsyncContext;